import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRightWhiteSmall = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 11,
	viewBox: "0 0 15 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.91577 0.99998L13.6642 5.59178L9.91577 10.1836",
		stroke: "white",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M1.28564 5.59177L13.6642 5.59177",
		stroke: "white",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgArrowRightWhiteSmall;
